module.exports = __webpack_public_path__ + "img/solutions5.001c5c45.jpeg";